import { BackupOutlined } from "@material-ui/icons";
import { Box, Grid, Typography } from "@mui/material";
import {
  AttachmentFilesCard,
  FormLabel,
  ModalError,
  ModalWarning,
} from "components";
import { useCallback, useMemo } from "react";
import { useDropzone } from "react-dropzone";
import { globalStyles } from "styles";
import { formatFileSize } from "utils";

function SupportingDocumentForm({
  supportingDocumentFiles,
  setSupportingDocumentFiles,
  fileType,
  multiple,
  label,
  maxFileSize,
  handleRemoveFile,
  useBorder = true,
  useDefaultLabel = true,
}) {
  const classes = globalStyles();

  const onDrop = useCallback(
    acceptedFiles => {
      const oversized = acceptedFiles.find(file => file.size > maxFileSize);
      if (oversized) {
        ModalError(
          `File size cannot be more than ${formatFileSize(maxFileSize)}`
        );
        return;
      }

      if (multiple) {
        const newFiles = [...supportingDocumentFiles, ...acceptedFiles].filter(
          (file, index, self) =>
            index === self.findIndex(f => f.name === file.name)
        );
        setSupportingDocumentFiles(newFiles);
      } else {
        setSupportingDocumentFiles(acceptedFiles.slice(0, 1));
      }
    },
    [multiple, supportingDocumentFiles, setSupportingDocumentFiles, maxFileSize]
  );
  const handleConfirmRemoveFile = (item, idx) => {
    ModalWarning(`Delete file ${item?.name}`).then(res => {
      if (res.isConfirmed) {
        onRemoveFile(item, idx);
      }
    });
  };
  const onRemoveFile = (item, idx) => {
    if (handleRemoveFile) {
      handleRemoveFile(item, idx);
    } else {
      setSupportingDocumentFiles(
        supportingDocumentFiles?.filter((_, index) => index !== idx)
      );
    }
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: fileType || ".pdf",
    multiple: multiple,
  });
  const dropzoneStyle = useMemo(() => {
    return isDragActive ? classes?.dragActive : "";
  }, [isDragActive, classes?.activeStyle]);

  return (
    <Box
      border={useBorder && "1px solid #ebebeb"}
      borderRadius={useBorder && "5px"}
      p={useBorder && "24px"}
    >
      <FormLabel label={useDefaultLabel ? label || "Upload Document" : ""} />
      <Box
        {...getRootProps({
          className: `${classes?.dragFilesContainer} ${dropzoneStyle}`,
        })}
      >
        <input {...getInputProps()} />
        <Box color="grey">
          <BackupOutlined className={classes?.uploadIcon} />
        </Box>
        <Typography>
          {isDragActive
            ? "Drop the files here..."
            : "Drag files or click to upload"}
        </Typography>
      </Box>
      {supportingDocumentFiles?.length > 0 && (
        <Box mt="16px">
          <FormLabel label="Files :" />
          <Grid container direction="column" rowSpacing={1}>
            {supportingDocumentFiles?.map((item, index) => (
              <Grid item key={index}>
                <AttachmentFilesCard
                  fileName={item?.name}
                  fileSize={item?.size ? formatFileSize(item?.size) : null}
                  filePath={item?.file_path}
                  tooltipRemove="Remove File"
                  handleRemove={() => handleConfirmRemoveFile(item, index)}
                />
              </Grid>
            ))}
          </Grid>
        </Box>
      )}
    </Box>
  );
}

export default SupportingDocumentForm;
